module.exports = __webpack_public_path__ + "modal-bg-m-2DY.png";